export const quickbooksTabs = {
  CUSTOM_FIELDS: 'custom_fields',
  CUSTOMERS: 'customers',
  PRODUCTS: 'products',
} as const;

export const tabLabels = {
  [quickbooksTabs.CUSTOM_FIELDS]: 'Custom Fields',
  [quickbooksTabs.CUSTOMERS]: 'Customers',
  [quickbooksTabs.PRODUCTS]: 'Products',
} as const;

export const tabConfig = [
  {
    key: 'quickbooks-dashboard-tab-custom-fields',
    tab: quickbooksTabs.CUSTOM_FIELDS,
  },
  {
    key: 'quickbooks-dashboard-tab-customers',
    tab: quickbooksTabs.CUSTOMERS,
  },
  {
    key: 'quickbooks-dashboard-tab-products',
    tab: quickbooksTabs.PRODUCTS,
  },
] as const;

export const tableRowsPerPage = {
  DEFAULT_ROWS_PER_PAGE: 10,
  ROWS_PER_PAGE_OPTIONS: [10, 25, 50],
} as const;
